import axios from 'axios';
import {useState, useEffect} from 'react';

import {URLS} from '../config';
import {FeeKindDetailsType} from '../types';

export const useGetFeeKindDetails = () => {
  const [feeKind, setFeeKind] = useState<FeeKindDetailsType[]>([]);
  const [feeKindLoading, setFeeKindLoading] = useState<boolean>(false);

  const getFeeKindDetails = async () => {
    setFeeKindLoading(true);

    try {
      const response = await axios.get(URLS.GET_FEE_KINDS_LOCAL);
      setFeeKind(response.data.feeKind);
    } catch (error) {
      console.error(error);
    } finally {
      setFeeKindLoading(false);
    }
  };

  useEffect(() => {
    getFeeKindDetails();
  }, []);

  return {feeKindLoading, feeKind};
};
